module.exports = __webpack_public_path__ + "img/logo-norton.1905a71.png";